import { transformDefinitions } from './transforms.es.js';

const isCssVar = (name) => name.startsWith("--");
const registeredProperties = new Set();
function registerCssVariable(name) {
    if (registeredProperties.has(name))
        return;
    registeredProperties.add(name);
    try {
        const { syntax, initialValue } = transformDefinitions.has(name)
            ? transformDefinitions.get(name)
            : {};
        CSS.registerProperty({
            name,
            inherits: false,
            syntax,
            initialValue,
        });
    }
    catch (e) { }
}

export { isCssVar, registerCssVariable, registeredProperties };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@motionone/dom/dist/animate/utils/css-var.es.js
// module id = N8K4
// module chunks = 0